import { render } from "./AlHistory.vue?vue&type=template&id=5e30b89a&ts=true"
import script from "./AlHistory.vue?vue&type=script&lang=ts"
export * from "./AlHistory.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__